import type { Theme } from '@freelancer/theme';

/**
 * Basename of the default “system” avatar for news/notifications, per resolved theme.
 * Pass the result to {@link Assets.getUrl}.
 */
export function getDefaultSystemImageAssetName(theme: Theme): string {
  return theme === 'dark'
    ? 'default-system-image-dark.svg'
    : 'default-system-image-light.svg';
}
